module.exports = __webpack_public_path__ + "img/mw.8627c92d.svg";